var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.model, function(item, key) {
        return _c("div", { key: key, staticClass: "cluster-row" }, [
          _c(
            "div",
            { staticClass: "cluster-field cluster-field--grow" },
            [
              _c(
                "label",
                {
                  staticClass: "cluster-label",
                  class: { bold: !_vm.isAlternative }
                },
                [_vm._v(" " + _vm._s(item.goal.name) + ": ")]
              ),
              !_vm.isAlternative
                ? _c("div", [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(item.goal.description)) + " "
                    )
                  ])
                : _vm._e(),
              _vm.isReadOnly && _vm.isAlternative
                ? _c("div", { staticClass: "cluster-value" }, [
                    _vm._v(" " + _vm._s(_vm._f("empty")(item.profession)) + " ")
                  ])
                : _vm._e(),
              _vm.isAlternative && !_vm.isReadOnly
                ? _c("validation-provider", {
                    staticClass: "cluster-input-wrap",
                    attrs: { rules: _vm.professionRules(item) },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                staticClass: "w-100",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  error: errors[0]
                                },
                                model: {
                                  value: item.profession,
                                  callback: function($$v) {
                                    _vm.$set(item, "profession", $$v)
                                  },
                                  expression: "item.profession"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "cluster-field" },
            [
              _c("label", { staticClass: "cluster-label" }, [
                _vm._v("Porcentaje:")
              ]),
              _vm.isReadOnly
                ? _c("div", { staticClass: "cluster-value" }, [
                    _vm._v(" " + _vm._s(_vm._f("empty")(item.number)) + " ")
                  ])
                : _c("validation-provider", {
                    staticClass:
                      "cluster-input-wrap cluster-input-wrap--number",
                    attrs: { rules: _vm.numberRules(item) },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors, failedRules }) {
                            return [
                              _c("custom-input", {
                                staticClass: "w-100",
                                attrs: {
                                  "custom-error-msg": _vm.getErrorMessage(
                                    failedRules
                                  ),
                                  error: errors[0],
                                  min: "0",
                                  placeholder: "0-100",
                                  type: "number"
                                },
                                model: {
                                  value: item.number,
                                  callback: function($$v) {
                                    _vm.$set(item, "number", $$v)
                                  },
                                  expression: "item.number"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
            ],
            1
          ),
          !_vm.isReadOnly && _vm.aggregable && key !== 0
            ? _c("span", {
                staticClass:
                  "fas fa-times-circle text-danger cursor-pointer cluster-remove",
                on: {
                  click: function($event) {
                    return _vm.$emit("remove", key)
                  }
                }
              })
            : _vm._e()
        ])
      }),
      !_vm.isReadOnly && _vm.aggregable && _vm.canAdd
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end mt-3" },
            [
              _c(
                "action-button",
                {
                  staticClass: "ml-2",
                  attrs: { i: "fas fa-file-plus", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("add")
                    }
                  }
                },
                [_vm._v(" Añadir ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }